import * as planosassinaturas from '@/api/planosassinaturas'

const state = {
  planosControle: [],
  planosControleLoading: false
}

const mutations = {
  PLANOSCONTROLE (state, payload) {
    state.planosControle = payload
  },
  PLANOSCONTROLELOADING (state, payload) {
    state.planosControleLoading = payload
  }
}

const actions = {
  async getPlanosAssinaturas ({ commit }) {
    let data = await planosassinaturas.getPlanosAssinaturas()
    return data.instancia
  },
  async editPlanosAssinaturas ({ commit }, payload) {
    let data = await planosassinaturas.editPlanosAssinaturas(payload)
    return data.instancia
  },
  async getPlanosControle ({ commit }, payload) {
    let data = await planosassinaturas.getPlanosControle(payload)
    return data.instancia
  },
  async editTodosPlanosControle ({ commit }, payload) {
    let data = await planosassinaturas.editTodosPlanosControle(payload)
    return data.instancia
  },
  async inativarPlano ({ commit }, payload) {
    let data = await planosassinaturas.inativarPlano(payload)
    return data.instancia
  },
  async buscarPlanosControle ({commit, state}, payload) {
    try {
      commit('PLANOSCONTROLELOADING', true)
      let planos = await planosassinaturas.buscarPlanosControle(payload)
      commit('PLANOSCONTROLE', planos.instancia)
    } catch (error) {
      throw (error)
    } finally {
      commit('PLANOSCONTROLELOADING', false)
    }
  }

}

export default { namespaced: true, state, mutations, actions }



// WEBPACK FOOTER //
// ./src/store/modules/gerenciador/planosassinaturas.js